import React from 'react';
import { S } from './style';
export default function ChoiceChip({ isSelected, isDisabled, content, onChipClick, }) {
    return (<S.Layout isSelected={isSelected} isDisabled={isDisabled} onClick={onChipClick}>
      {content}
    </S.Layout>);
}
